import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import TreeView from "../components/TreeView";
import { ParameterAPI, MeasureAPI,BlobAPI } from "../services/api";
import ParametersTable from "../components/ParametersTable";
import { useSession } from "../context/SessionContext";
import ImportWizPanel from "../components/ImportWizPanel";
import AppHeader from "../components/AppHeader";
import SpecificationsAccordion from "../components/SpecificationsAccordion";

import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from "react-resizable-panels";



const ProjectDashboard = () => {
  const { id } = useParams<{ id: string }>();
  const [selectedNode, setSelectedNode] = useState<any>(null);
  const [parameters, setParameters] = useState<any[]>([]);
  const [loadingParams, setLoadingParams] = useState(false);
  const [tbv, setTbv] = useState<number | null>(null);
  const [refreshTree, setRefreshTree] = useState<number>(0);

  const userName = localStorage.getItem("userName");
  const navigate = useNavigate();
  const location = useLocation();
 // const projectName = location.state?.projectName;
 const [projectName, setProjectName] = useState(
  location.state?.projectName || localStorage.getItem("projectName") || ""
);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const [showZoom, setShowZoom] = useState(false);

const [zoomPos, setZoomPos] = useState({
  x: 50,
  y: 50,
});

const ZOOM = 2.5;
const ZOOM_PANEL_WIDTH = 420;
const ZOOM_PANEL_HEIGHT = 420;


const [lensPos, setLensPos] = useState({
  x: 0,
  y: 0,
});
 /*  useEffect(() => {
  const loadImage = async () => {
    if (!selectedNode?.notationHead) {
      setImageUrl(null);
      return;
    }

    try {
      console.log("NotationHead:", selectedNode.notationHead);

      const url = await BlobAPI.getImage(
        "Notation1",
        selectedNode.notationHead
      );

      setImageUrl(url);
    } catch (err) {
      console.error("Image load failed", err);
      setImageUrl(null);
    }
  };

  loadImage();
}, [selectedNode]); */
useEffect(() => {
  const loadImage = async () => {
    if (!selectedNode) {
      setImageUrl(null);
      return;
    }

    try {
      let url: string | null = null;

      // Notation Image
      if (selectedNode.notationNo && selectedNode.notationHead) {
        console.log("NotationHead:", selectedNode.notationHead);

        url = await BlobAPI.getImage(
          "Notation1",
          selectedNode.notationHead
        );
      }

      // WBS Image
      else if (selectedNode.wbsNo && selectedNode.sequence) {
        console.log("Sequence:", selectedNode.sequence);

        url = await BlobAPI.getImage(
          "WorkTree1",
          selectedNode.sequence
        );
      }

      setImageUrl(url);
    } catch (err) {
      console.error("Image load failed", err);
      setImageUrl(null);
    }
  };

  loadImage();
}, [selectedNode]);

  useEffect(() => {
    if (projectName) {
      localStorage.setItem("projectName", projectName);
    }
  }, [projectName]);


  // ADD THIS FUNCTION HERE
/* const handleImageMove = (
  e: React.MouseEvent<HTMLDivElement, MouseEvent>
) => {
  const rect = e.currentTarget.getBoundingClientRect();

  const x = ((e.clientX - rect.left) / rect.width) * 100;
  const y = ((e.clientY - rect.top) / rect.height) * 100;

  setZoomPos({
    x: Math.min(100, Math.max(0, x)),
    y: Math.min(100, Math.max(0, y)),
  });
}; */
const handleImageMove = (
  e: React.MouseEvent<HTMLDivElement>
) => {
  const rect = e.currentTarget.getBoundingClientRect();

  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;

  setLensPos({
    x,
    y,
  });

  setZoomPos({
    x: (x / rect.width) * 100,
    y: (y / rect.height) * 100,
  });
};

  const { sessionNo } = useSession();

  if (sessionNo === null) {
    return <p className="p-4">Loading session...</p>;
  }

  const handleUpdateParameters = async (
    updated: any[],
    index: number,
    field: string
  ) => {
    const item = updated[index];

    try {
      if (field === "value") {
        const result = await MeasureAPI.update({
          wmno: item.id,
          sno: sessionNo,
          mval: Number(item.value),
          axn: "ParameterUpdate",
        });

        const changed = result.Q_Parameters ?? [];

        if (changed.length > 0) {
          const mapped = changed.map((p: any) => ({
            id: p.ParameterNo,
            parameter: p.Parameter,
            value: p.Value,
          }));

          setParameters(mapped);
        } else {
          setParameters(updated);
        }
      }
    } catch (err) {
      console.error("Update failed:", err);
    }
  };

  if (!id) return <p className="p-4">Invalid project</p>;

  return (
    // <div className="h-screen flex flex-col bg-gradient-to-br from-gray-50 to-gray-200">
   
  <div
    className="h-screen flex flex-col bg-gradient-to-br from-gray-50 to-gray-200"
    style={{
      fontFamily: "'Segoe UI', sans-serif",
      fontSize: "13px",
      fontWeight: 400,
    }}
  >
      
      <AppHeader
  title={projectName || id || "Dashboard"}
  userName={userName}
  activeTab="dashboard"
  onBack={() => navigate(-1)}
  onHome={() => navigate("/projects")}
  onDashboard={() => navigate(`/project/${id}`)}
  onSecond={() => navigate(`/project/${id}/second`)}
  onThird={() => navigate(`/project/${id}/third`)}
  onFourth={() => navigate(`/project/${id}/fourth`)}
   onFifth={() => navigate(`/project/${id}/fifth`)}
  /* onLogout={() => {
    localStorage.removeItem("token");
    navigate("/login"); */
   /*  onLogout={() => {
  Object.keys(sessionStorage).forEach((key) => {
    if (
      key.startsWith("treeSelection-") ||
      key.startsWith("treeOpenNodes-")
    ) {
      sessionStorage.removeItem(key);
    }
  });

  localStorage.removeItem("token");
  navigate("/login");

  }} */
 onLogout={() => {
  sessionStorage.clear();

  localStorage.removeItem("token");

  navigate("/login");
}}


  projectId={Number(id)}
  onProjectUpdated={(updatedName) => {
    setProjectName(updatedName);
  }}
/>

       
        {/* <div className="grid grid-cols-[1fr_1.5fr_1.5fr] gap-0 p-0 flex-1 min-h-0 overflow-hidden">   */}
        <PanelGroup direction="horizontal" className="flex-1 min-h-0">
      
        {/* LEFT PANEL */}
       

<Panel defaultSize={25} minSize={15}>
 <div
  className="flex flex-col h-full min-h-0 overflow-hidden " 
 
  style={{
    backgroundColor: "#FFFFFF"
  }}
>

        
          <div
 // className="h-14 px-4 flex items-center"
className="px-4 pt-4 pb-2"
  style={{ 
   
    backgroundColor: "#FFFFFF"
    }}
>
            {/* <h2 className="text-md font-semibold text-gray-700 flex items-center gap-2 leading-none"> */}
            <h2 className="text-gray-700 flex items-center gap-2 leading-none">
               Work Breakdown Structure
            </h2>
          </div>

         
          <div
  className="flex-1 min-h-0 overflow-y-auto p-0"
  style={{ 
   
    backgroundColor: "#FFFFFF"
    }}
>
           {/*  <TreeView
              projectId={parseInt(id)}
              refresh={refreshTree}
              onSelect={async (node: any) => {
                setSelectedNode(node);

                const isRoot = node.tag === 0 && !node.wbsNo && !node.notationNo;

                const importTbv = isRoot
                  ? 0
                  : node.notationNo
                  ? -node.notationNo
                  : node.tag;

                const paramTbv = node.tag;
                setTbv(importTbv);

                try {
                  setLoadingParams(true);
                  const data = await ParameterAPI.getBySet(
                    paramTbv,
                    Number(id),
                    sessionNo
                  );
                  setParameters(data);
                } catch (err) {
                  console.error(err);
                  setParameters([]);
                } finally {
                  setLoadingParams(false);
                }
              }}
            /> */}
            <TreeView
  projectId={parseInt(id)}
  refresh={refreshTree}
  onSelect={(node: any) => {
    setSelectedNode(node);

    const isRoot = node.tag === 0 && !node.wbsNo && !node.notationNo;

    const importTbv = isRoot
      ? 0
      : node.notationNo
      ? -node.notationNo
      : node.tag;

    setTbv(importTbv);

    // Don't load parameters
    setParameters([]);
    setLoadingParams(false);
  }}
/>


          </div>
        </div>

         </Panel>

    {/*   <PanelResizeHandle className="w-2px bg-gray-500  cursor-col-resize">
        <div className="h-full w-px mx-auto " />
      </PanelResizeHandle> */}
 <PanelResizeHandle className="w-px shrink-0 bg-white border-0 cursor-col-resize" />
      <Panel defaultSize={40} minSize={20}> 


        {/* MIDDLE PANEL */}
       
         <div
  className="flex flex-col h-full min-h-0 overflow-hidden   "
 
 style={{ backgroundColor: "#FFFFFF" }}
>
          
       {/*   <div

 className="px-4 pt-4 pb-1"
 
 
  style={{ backgroundColor: "#FFFFFF" }}
>
          
            <h2 className="text-gray-700 flex items-center gap-2 leading-none">
              📊 Detail Area
            </h2>
          </div>

          
<div
  className="flex-1 min-h-0 overflow-y-auto hide-scrollbar p-0 space-y-0"
  style={{ backgroundColor: "#FFFFFF" }}
>
            <div>
              {parameters.length === 0 ? (
                // <div className="flex items-center justify-center h-40 text-gray-400 text-sm">
                <div className="flex items-center justify-center h-40 text-gray-400">
                  Select a node to view parameters
                </div>
              ) : (
                <ParametersTable
                  data={parameters}
                  loading={loadingParams}
                  onUpdate={handleUpdateParameters}
                />
              )}
            </div>

            <div>
              <SpecificationsAccordion
                projectId={parseInt(id)}
                selectedNode={selectedNode}
              />
            </div>

           
            <div className="pt-1">
          
              <div className="pt-1">
              
                <div className="w-full bg-white flex flex-col items-center">
                  {imageUrl ? (
                    <>
                  
  <div
  className="relative"
  onMouseEnter={() => setShowZoom(true)}
  onMouseLeave={() => setShowZoom(false)}
  onMouseMove={handleImageMove}
>
  <img
    src={imageUrl}
    alt="Preview"
    className="max-h-[280px] max-w-full object-contain "
  />
{showZoom && (
  <div
    style={{
      position: "absolute",
     width: 120,
height: 120,
left: lensPos.x - 60,
top: lensPos.y - 60,
      border: "2px solid #666",
      background: "rgba(255,255,255,0.35)",
      pointerEvents: "none",
      boxSizing: "border-box",
    }}
  
  

  />
)}


  
</div> 
                  
                  
{showZoom && imageUrl && (
  <div
    className="mt-2 h-72 w-full border border-gray-300 overflow-hidden"
    style={{
      backgroundImage: `url(${imageUrl})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "250%",
      backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`,
    }}
  />
)}
</>
              ) : (
  <></>
)}    

                
                  
                </div>
              </div>
            </div>
          </div>
        </div>*/}
</div>

          </Panel> 

      
      <PanelResizeHandle className=" cursor-col-resize" />

      <Panel defaultSize={35} minSize={20}>


        {/* RIGHT PANEL */}
        
          <div
  className="flex flex-col h-full min-h-0 overflow-hidden "
 
  style={{ backgroundColor: "#FFFFFF" }}
>
          {/* <div className="h-14 px-4 border-b border-gray-300 bg-white flex items-center"> */}
          {/* <div className="h-14 px-4 bg-white flex items-center"> */}
          <div
  //className="h-14 px-4 flex items-center"
  className="px-4 pt-4 pb-1"
 
  style={{ backgroundColor: "#FFFFFF" }}
>
            {/* <h2 className="text-md font-semibold text-gray-700 flex items-center gap-2 leading-none"> */}
            <h2 className="text-gray-700 flex items-center gap-2 leading-none">
              ⚙️ Feature Area
            </h2>
          </div>

         
          <div
  className="flex-1 min-h-0 overflow-y-auto p-0 space-y-0"
  
  style={{ backgroundColor: "#FFFFFF" }}
>
          

  <ImportWizPanel
    tbv={tbv}
    projectId={parseInt(id)}
    sessionNo={sessionNo}
    selectedNode={selectedNode}
    onAdded={() => {
      setRefreshTree((prev) => prev + 1);
      if (selectedNode) {
        setSelectedNode({ ...selectedNode });
      }
    }}
  />

          </div>
          </div>
          </Panel>
    </PanelGroup>
        </div>
      
   
  );
};

export default ProjectDashboard;
